import _asyncToGenerator from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.object.to-string.js";
import "regenerator-runtime/runtime.js";
import { defineComponent, ref } from "vue";
import { useI18n } from "vue-i18n";
import { LogLevel, LogService } from "@/services/logging";
export default defineComponent({
  name: "CustomerSeatingChart",
  props: {
    chartData: {
      required: true,
      type: Object
    }
  },
  setup: function setup(props) {
    var _useI18n = useI18n({}),
        t = _useI18n.t;

    var seatsio = ref(null);
    var chart = ref(null);
    var divId = ref(props.chartData.divId);
    console.log("divId");
    console.log(divId);
    return {
      t: t,
      seatsio: seatsio,
      divId: divId,
      chart: chart
    };
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var dialog;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              /////////////////
              dialog = document.querySelector("dialog");

              if (!dialog) {
                _context.next = 20;
                break;
              }

              dialog.showModal(); // Seating Plan chart rendering in spotlight mode

              _context.prev = 3;
              _context.prev = 4;
              _context.next = 7;
              return _this.loadChartJS();

            case 7:
              _context.next = 14;
              break;

            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](4);
              console.error("Failed to load Chart.js", _context.t0);
              LogService.info("Error, failed to load Chart.js", _context.t0, LogLevel.Error);
              dialog.close();

            case 14:
              _this.seatsio = window.seatsio;
              _this.isChartRendering = true;

              _this.renderChart();

              _this.isChartRendering = false;

            case 18:
              _context.prev = 18;
              return _context.finish(18);

            case 20:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[3,, 18, 20], [4, 9]]);
    }))();
  },
  methods: {
    loadChartJS: function loadChartJS() {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var script;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                // Check if the script element already exists
                script = document.getElementById("chartScript");

                if (script) {
                  _context2.next = 11;
                  break;
                }

                // If script element doesn't exist, create it
                script = document.createElement("script");
                script.id = "chartScript";
                script.src = "https://cdn.seatsio.net/chart.js";
                script.async = true;
                document.body.appendChild(script); // Wait for script to load

                _context2.next = 9;
                return new Promise(function (resolve, reject) {
                  script.onload = resolve;
                  script.onerror = reject;
                });

              case 9:
                _context2.next = 12;
                break;

              case 11:
                // If script element already exists, log a message (optional)
                LogService.info("Chart.js script already loaded");

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    renderChart: function renderChart() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var chartConfig;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                try {
                  chartConfig = _this2.$props.chartData; // SeatsIO Docs: In this mode interaction is disabled and session cannot be started nor continued.
                  // SeatsIO Docs:
                  // In order to mark which seats should be displayed as selected, you may:
                  // 1- Set the selectedObjects configuration parameter.
                  // 2- Use the chart.doSelectObjects() and chart.deselectObjects() methods.
                  // chartConfig.selectedObjects = ["G-B-26"];
                  // delete chartConfig.selectedObjectsInputName;

                  LogService.info("Customer display chartConfig attached", {
                    params: chartConfig
                  });
                  _this2.chart = new _this2.seatsio.SeatingChart(chartConfig).render();
                } catch (err) {
                  LogService.info("Error, failed to render chart", err, LogLevel.Error);
                }

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    selectObjects: function selectObjects(newlySelectedObjects) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this3.chart.doSelectObjects(newlySelectedObjects);

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    deselectObjects: function deselectObjects(deselectedObjects) {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this4.chart.deselectObjects(deselectedObjects);

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    }
  }
});